import React, { useContext, useEffect, useState } from 'react';
import _classNames from 'classnames';
import _get from 'lodash/get';
import _has from 'lodash/has';
import _isEmpty from 'lodash/isEmpty';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import ButtonBase from '@material-ui/core/ButtonBase';
import LoadingIndicator from 'components/LoadingIndicator';
import GuideMeContext from './GuideMeContext';
import TopicOptionB from './TopicOptionB';
import MediaTypeOptionB from './MediaTypeOptionB';

const useStyles = makeStyles(theme => ({
  root: {
    height: 105,
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'rgba(1, 97, 155, 0.9)',
    alignItems: 'center',
    [theme.breakpoints.down('600')]: {
      height: '255px !important',
    },
  },
  landingPage: {
    height: 105,
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.1)',
    alignItems: 'center',
    [theme.breakpoints.down('600')]: {
      height: '255px !important',
    },
  },
  topics: {
    marginBottom: 12,
    marginTop: 24,
  },
  button: {
    ...theme.typography.button,
    color: '#fff',
    boxShadow: 'none',
    width: 163,
    height: 40,
    backgroundColor: theme.palette.primary.main,
    borderRadius: 2,
    zIndex: 9,
  },
  selectAllWrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    marginBottom: 8,
  },
  selectAllButton: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    backgroundColor: '#FFFFFF',
    borderRadius: 18,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#ECECEC',
    padding: '7px 14px',
    color: '#4B4B4B',
    cursor: 'pointer',
    ...theme.typography.pBold,
  },
  selectAllActive: {
    borderColor: '#01619B',
    backgroundColor: '#01619B',
    color: '#FFFFFF',
  },

  containerWrap: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    marginLeft: -4,
    marginRight: -4,
  },
  containerWrapTopics: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  containerWrapAudiences: {
    display: 'flex',
    flexWrap: 'wrap',
    paddingLeft: '10% !important',
    paddingRight: '10% !important',
  },
}));

function Content() {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const {
    themes,
    topics,
    mediaTypes,
    currentStep,
    // filter,

    themeOptions,
    mediaTypeOptions,
    config,

    onSelect,

    dialogContentRef,
  } = useContext(GuideMeContext);

  useEffect(() => {
    setOpen(false);
    if (_has(dialogContentRef, 'current.scrollTo'))
      dialogContentRef.current.scrollTo({ top: 0, behavior: 'smooth' });
  }, [currentStep]);

  const content = () => {
    if (config.steps[currentStep].type === 'themes') {
      return (
        <Grid item xs={12} className={classes.containerWrapTopics}>
          {themeOptions.map(theme => {
            const selected = themes.includes(theme);

            return (
              <TopicOptionB
                key={theme.sys.id}
                data={theme}
                type="themes"
                selected={selected}
                onSelect={onSelect}
              />
            );
          })}
        </Grid>
      );
    }
    if (config.steps[currentStep].type === 'topics') {
      const availableTopics = [];
      themes.forEach(theme => {
        if (theme.fields) {
          const availableTopicsIds = availableTopics.map(
            availableTopic => availableTopic.id,
          );
          _get(theme, 'fields.topics', []).forEach(topic => {
            if (!availableTopicsIds.includes(topic.id))
              availableTopics.push(topic);
          });
        }
      });
      return (
        <>
          <Grid item xs={12} className={classes.containerWrapTopics}>
            {availableTopics
              .sort((a, b) => {
                if (b.title > a.title) return -1;
                if (b.title < a.title) return 1;
                return 0;
              })
              .slice(0, open ? undefined : 20)
              .map(topic => {
                const selected = topics.includes(topic);

                return (
                  <TopicOptionB
                    key={topic.id}
                    data={topic}
                    type="topics"
                    selected={selected}
                    onSelect={onSelect}
                  />
                );
              })}
          </Grid>
          {!open && availableTopics.length > 20 && (
            <Grid item xs={12} className={classes.containerWrapTopics}>
              <ButtonBase
                className={classes.button}
                disableRipple
                onClick={() => setOpen(true)}
              >
                SHOW MORE
              </ButtonBase>
            </Grid>
          )}
          <Grid item xs={12} />
        </>
      );
    }
    if (config.steps[currentStep].type === 'mediaTypes') {
      if (_isEmpty(mediaTypeOptions)) return <LoadingIndicator />;

      return (
        <Grid item xs={12} className={classes.containerWrapTopics}>
          <div className={classes.selectAllWrapper}>
            <ButtonBase
              className={_classNames({
                [classes.selectAllButton]: true,
                [classes.selectAllActive]:
                  mediaTypes.length === (mediaTypeOptions || []).length,
              })}
              disableRipple
              onClick={() => onSelect('mediaTypes', 'all')}
            >
              Select All
            </ButtonBase>
          </div>
          {mediaTypeOptions.map(mediaType => {
            const selected = mediaTypes.includes(mediaType);

            return (
              <MediaTypeOptionB
                key={mediaType.value}
                data={mediaType}
                type="mediaTypes"
                selected={selected}
                onSelect={onSelect}
              />
            );
          })}
        </Grid>
      );
    }
    return null;
  };

  return (
    <Grid container spacing={2} justifyContent="space-between">
      {content()}
    </Grid>
  );
}

export default Content;
